<div fxLayout="column" fxLayoutAlign="stretch">
  @if (isGuest) {
    <button
      aria-label="Login"
      class="btn btn-primary"
      title="Login"
      type="button"
      (click)="login()"
    >
      Login
    </button>
  } @else {
    <div class="button-width">
      @if (format === 'eMagazine' && item.magazineIssues?.products.length) {
        <div class="margin-top-10">
          <h6 class="text-center">Issue: {{ magazineEdition }}</h6>
          <button
            role="button"
            type="button"
            aria-label="Select An Issue"
            class="btn btn-primary width-100"
            (click)="openDialog()"
          >
            Select An Issue
          </button>
        </div>
      }
      <div class="button-width">
        @if (!item.isCheckedOut && item.samples[0]) {
          <button
            role="button"
            type="button"
            aria-label="View Sample"
            class="btn btn-primary item-buttons"
            title="View Sample Material"
            (click)="showSample(item.samples[0].url)"
          >
            {{ format === 'Audiobook' ? 'Listen To Sample' : 'Read Sample' }}
          </button>
        }
      </div>
      @if (!item.isReserved && !item.availability.available && !item.isCheckedOut) {
        <button
          role="button"
          type="button"
          aria-label="Place Hold"
          class="btn btn-primary item-buttons"
          (click)="placeItemHold()"
        >
          Place Hold
        </button>
      } @else {
        @if (item.isReserved) {
          <button
            role="button"
            type="button"
            aria-label="Cancel Hold"
            class="btn btn-primary item-buttons"
            title="Cancel Hold"
            (click)="cancelOverDriveHold()"
          >
            Cancel Hold
          </button>
        }
        @if (item.isCheckedOut) {
          <button
            role="button"
            type="button"
            aria-label="Early Return Overdrive"
            class="btn btn-primary item-buttons"
            title="Early Return"
            (click)="earlyReturn()"
          >
            Early Return
          </button>
        }
        @if (item.isCheckedOut) {
          <button
            role="button"
            type="button"
            aria-label="'Get' format"
            class="btn btn-primary item-buttons"
            (click)="goToOverDriveFulfillment()"
          >
            Get {{ format }}
          </button>
        } @else {
          @if (
            (item.isReadyForPickup && item.isReserved) || (!item.isCheckedOut && !item.isReserved)
          ) {
            <button
              role="button"
              type="button"
              aria-label="Read In Browser"
              class="btn btn-primary item-buttons"
              title="Checkout"
              (click)="checkout()"
            >
              Checkout
            </button>
          }
        }
      }
    </div>
  }
</div>
